<i18n src="@/locales/components/CbsDynamicFormConfig.json"></i18n>

<template>
	<div class="repeater-field-config">
		<legend class="repeater-field-config__header flex justify-between items-center">
			<div>{{ $t("FieldConfig.ListFields") }}<span class="text-danger">&nbsp;*</span>:</div>
			<i class="nucleo nucleo-c-add-2 btn-add-data-reapeater cursor-pointer text-2xl" v-if="isEditable" :title="$t('FieldConfig.AddData')" @click="handleClickAddRepeaterField" />
		</legend>

		<form-fields-draggable
			class="-mx-6"
			v-show="value && value.length"
			:value="value"
			:delay="200"
			:delayOnTouchOnly="true"
			:isEditable="isEditable"
			@onClickItem="handleClickField"
			@onClickDelete="handleDeleteField"
			@onSort="sortData => $emit('input', sortData)"
		/>

		<config-field-dialog
			v-if="isShowConfigFieldDialog"
			v-model="configFieldData.value"
			:isEditable="isEditable"
			:isCreateMode="isCreateMode"
			:title="configFieldData.title"
			:formFields="configFieldData.formFields"
			:isDialogActive="isShowConfigFieldDialog"
			@closeDialog="toggleConfigFieldDialog"
			@onSubmit="handleCreateOrUpdateField"
		/>
	</div>
</template>

<script>
import _ from "lodash";
import FormFieldsDraggable from "./FormFieldsDraggable";

const initRequestTypeFieldData = {
  id: null,
  title: "",
  children: [],
  control: null,
  attributes: null,
  is_optional: false,
  enable: true,
  description: {
    value: "",
    enable: false,
    position: null
  }
};

export default {
	inheritAttrs: false,
	name: "RepeaterFieldConfig",
	components: { FormFieldsDraggable, ConfigFieldDialog: () => import("./ConfigFieldDialog") },
	props: {
		value: {
			type: Array,
			default() {
				return [];
			},
			validator: prop => {
				if (!_.isEmpty(prop)) {
					return prop.every(
						objData =>
							_.has(objData, "id") &&
							_.has(objData, "title") &&
							_.has(objData, "control") &&
							_.has(objData, "children") &&
							_.has(objData, "attributes") &&
							_.has(objData, "is_optional") &&
							_.has(objData, "description")
					);
				}
				return true;
			}
		},
		isEditable: {
			type: Boolean,
			default: true
		}
	},
	emits: {
		onClickEditItem: {},
		onClickDeleteField: {}
	},
	data() {
		return {
			isCreateMode: null,
			currentEditIndex: null,

			configFieldData: null,
			isShowConfigFieldDialog: false
		};
	},
	methods: {
		toggleConfigFieldDialog(val = false) {
			this.isShowConfigFieldDialog = val;
		},
		handleClickAddRepeaterField() {
			this.isCreateMode = true;
			const requestTypeFieldTitle = this.$t("FieldConfig.CreateRepeaterField");
			this.configFieldData = {
				title: requestTypeFieldTitle,
				formFields: this.value || [],
				value: { ...initRequestTypeFieldData }
			};
			this.toggleConfigFieldDialog(true);
		},
		handleCreateOrUpdateField() {
			const fieldData = { ...this.configFieldData.value };
			if (!this.isCreateMode) {
				this.$emit(
					"input",
					this.value.map((field, index) => {
						if (index === this.currentEditIndex) {
							return fieldData;
						}
						return field;
					})
				);
			} else {
				this.$emit("input", [...this.value, fieldData]);
			}

			this.toggleConfigFieldDialog(false);
		},
		handleClickField(fieldData, fieldIndex) {
			this.isCreateMode = false;
			this.currentEditIndex = fieldIndex;
			const requestTypeFieldTitle = this.$t("FieldConfig.EditRepeaterField");
			this.configFieldData = {
				title: requestTypeFieldTitle,
				formFields: this.value || [],
				value: _.cloneDeep(fieldData)
			};
			this.toggleConfigFieldDialog(true);
		},
		handleDeleteField(fieldData, fieldIndex) {
			if (fieldData.id) {
				this.$emit("input", [...this.value.filter(field => field.id !== fieldData.id)]);
			} else {
				this.$emit("input", [...this.value.filter((field, index) => index !== fieldIndex)]);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.custom-nested-dialog.request-type-field-dialog {
	&:not(:last-child) {
		background: none !important;
	}
}
</style>
